import React from 'react';
import { __t } from '../../../../../base/utils/t';
import { useIsMobile } from '../../../../../base/hooks';
import { Chip } from '../../../../../base/components/Chip';
import { Icon } from '../../../../../base/components/Icon';
import { FavoritesButton } from '../../../../../base/components/FavoritesButton';
import { VacancyCardData } from '../../interfaces';
import { pluralize } from '../../../../../base/utils';

import './styles.scss';

interface Props extends VacancyCardData {
    onFavoritesClick: (vacancyId: number, isFavorite: boolean) => void;
}

export const VacancyCard = ({
    id,
    name,
    rateFrom,
    rateTo,
    currency,
    rateType,
    city,
    workersCount,
    tagIds,
    isFavorite,
    isUpgraded,
    onFavoritesClick,
}: Props) => {
    const isMobile = useIsMobile();

    const rate = `${rateFrom}${rateTo ? ` - ${rateTo}` : ''} ${currency}/${rateType}`;
    const location = `${city.name}, ${city.country.name}`;

    const pluralizedWorkersCountTexts = [__t('работник'), __t('работника'), __t('работников')];

    const favoritesClickHandler = () => onFavoritesClick(id, !isFavorite);

    return (
        <div className='app-vacancy-card'>
            <div className='app-vacancy-card__favorties-button'>
                <FavoritesButton isFavorite={isFavorite} onClick={favoritesClickHandler} />
            </div>

            <a href='' className='app-vacancy-card__title' title={name}>
                {isUpgraded && <>🔥&nbsp;</>}
                {name}
            </a>

            {!isMobile && (
                <div className='app-vacancy-card__rate ' title={rate}>
                    {rate}
                </div>
            )}

            {isMobile && (
                <div className='app-vacancy-card__info-item'>
                    <Icon icon='coins-light' size='20px' />
                    <span
                        className='app-vacancy-card__info-item-text app-vacancy-card__info-item-text--rate'
                        title={rate}
                    >
                        {rate}
                    </span>
                </div>
            )}

            <div className='app-vacancy-card__info-item'>
                <Icon icon='location-dot-light' size='20px' />
                <span className='app-vacancy-card__info-item-text' title={location}>
                    {location}
                </span>
            </div>

            {!isMobile && (
                <div className='app-vacancy-card__info-item'>
                    <Icon icon='user-helmet-safety-light' size='20px' />
                    <span className='app-vacancy-card__info-item-text'>
                        {workersCount} {pluralize(workersCount, pluralizedWorkersCountTexts)}
                    </span>
                </div>
            )}

            {/* 
            {!isMobile && (
                <div className='app-vacancy-card__info-item'>
                    <Icon icon='briefcase-light' size='20px' />

                    <span
                        className={`app-vacancy-card__info-item-text ${
                            showContacts ? 'app-vacancy-card__info-item-text--with-icon' : ''
                        }`}
                        title='<?= $vacancy->employer->name ?>'
                    >
                        {showContacts ? 'Company name Company name Company name' : '********'}
                    </span>

                    {showContacts && (
                        <i
                            aria-hidden='true'
                            className='icon-badge-check-solid i-highlight app-vacancy-card__verified-badge'
                        ></i>
                    )}
                </div>
            )}

            {!isMobile && (
                <div className='app-vacancy-card__info-item'>
                    <Icon icon='file-check-light' size='20px' />

                    <ClickTooltip
                        align='left'
                        activeButton={
                            <span
                                className='app-vacancy-card__info-item-text app-vacancy-card__info-item-text--underline'
                                title='<?= $vacancy->employer->name ?>'
                            >
                                {__t('Смотреть контакты')}
                            </span>
                        }
                    >
                        <div className='app-vacancy-card__contacts-unavailable-tooltip'>
                            <p className='app-vacancy-card__contacts-unavailable-tooltip-text'>
                                {isVacancyPromoted
                                    ? __t('Нажмите «Откликнуться», если вас заинтересовала вакансия.')
                                    : __t(
                                          'Этот работодатель предпочитает самостоятельно связываться. Нажмите «Откликнуться», если вас заинтересовала вакансия.',
                                      )}
                            </p>
                            <Button type='secondary' className='app-vacancy-card__contacts-unavailable-tooltip-button'>
                                {__t('Откликнуться')}
                            </Button>
                        </div>
                    </ClickTooltip>
                </div>
            )} */}

            <div className='app-vacancy-card__labels-wrap'>
                {tagIds.includes(15) && (
                    <Chip
                        text={__t('Отклик без анкеты')}
                        icon='bolt-solid'
                        iconColor='purple'
                        iconSize='10px'
                        type='purple'
                        className='app-vacancy-card__label'
                    />
                )}

                {tagIds.includes(11) && (
                    <Chip text={__t('Работа на сейчас')} type='danger' className='app-vacancy-card__label' />
                )}
                {tagIds.includes(5) && <Chip text={__t('Питание')} type='green' className='app-vacancy-card__label' />}
                {tagIds.includes(9) && (
                    <Chip text={__t('Без опыта работы')} type='brown' className='app-vacancy-card__label' />
                )}
                {tagIds.includes(10) && (
                    <Chip text={__t('Биометрический паспорт')} type='blue' className='app-vacancy-card__label' />
                )}
                {tagIds.includes(4) && (
                    <Chip text={__t('С жильем')} type='violet' className='app-vacancy-card__label' />
                )}
                {tagIds.includes(14) && (
                    <Chip text={__t('Удаленная работа')} type='dark-blue' className='app-vacancy-card__label' />
                )}
            </div>
        </div>
    );
};
